module.exports = [{"type":"hash","text":"Heartbeats"},{"type":"normal","text":"Once the Websocket Client and Websocket Server get connected, the server will send a heartbeat- Ping message every 5 seconds (the frequency might change)."},{"type":"normal","text":"When the Websocket Client receives this heartbeat message, it should return Pong message."}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/introduce/03_heart_beat.json
// module id = IMXD
// module chunks = 3